import React, { useEffect, useState } from "react";

interface CurrentLocationProps {
  lat?: number;
  lng?: number;
}

const CurrentLocation: React.FC<CurrentLocationProps> = ({ lat, lng }) => {
  const [userLocation, setUserLocation] = useState("Loading...");

const getLocationFromAPI = async (
  latitude: number,
  longitude: number
) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
    );

    const data = await res.json();

    const state =
      data.address?.state ||
      data.address?.region ||
      "";

    const country =
      data.address?.country || "";

    setUserLocation(
      `${state}, ${country}`
    );
  } catch (e) {
    console.error("Location Error:", e);
    setUserLocation(
      "Error Fetching Location"
    );
  }
};

  useEffect(() => {
    // 👉 Case 1: lat/lng provided as props
    if (lat && lng) {
      getLocationFromAPI(lat, lng);
      return;
    }

    // 👉 Case 2: No props → use device GPS
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getLocationFromAPI(latitude, longitude);
        },
        (error) => {
          console.error("Geolocation error:", error);
          setUserLocation("Permission Denied");
        }
      );
    } else {
      setUserLocation("Geolocation Not Supported");
    }
  }, [lat, lng]);

  return <>{userLocation}</>;
};

export default CurrentLocation;
